import { Model } from '@/models/Model';
export class RosterTemplate extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'RosterTemplate';
        this.$endpoint = '/templates';
        this.$fillable = ['title', 'start_day', 'length_in_days'];
    }
    duplicate(id) {
        this.$endpoint = `/templates/${id}/duplicate`;
        return this;
    }
    getFilterLabel() {
        return this.title || '';
    }
    default() {
        this.$endpoint = '/templates';
        return this;
    }
}
